import SectionTitle from '../components/Assets/sectionTitle';
import TabContainer from '../components/Assets/TabContainer';
import { assistanceTabArray } from '../components/Assistance/arrayDatas';
import FaqTab from '../components/Assistance/FaqTab';
import VideoTab from '../components/Assistance/VideoTab';
import { getAppManagerState } from '../store/appManager/reducer';

import { useAppSelector } from '../App/redux/store';
import Button from '../components/Assets/Button';
import './styles/assistancePage.scss';

function AssistancePage() {
  const { selectedAssistanceTab } = useAppSelector(getAppManagerState);

  const handleContactSupport = () => {
    window.open(
      'mailto:support@urbanease.io?subject=Prospec Immo - demande de support',
      '_blank',
    );
  };

  return (
    <>
      <header className="assistance-header">
        <SectionTitle
          mainTitle={`Assistance`}
          subTitle="Quelques vidéos pour vous aider..."
        />
        <Button
          btnType="button"
          btnContent="CONTACTER LE SUPPORT"
          handleClick={handleContactSupport}
          primary
        />
      </header>

      <div className="assistance">
        <TabContainer tabArray={assistanceTabArray} type="assistance" />

        {selectedAssistanceTab === 0 && <VideoTab />}
        {selectedAssistanceTab === 1 && <FaqTab />}
      </div>
    </>
  );
}

export default AssistancePage;
